import { styled } from 'styled-components';

export const BannerErrorWrapper = styled.div`
  display: flex;
  line-height: 1.6;
  gap: ${({ theme }) => theme.sizing.small};
  border: 1px solid ${({ theme }) => theme.colours.messaging.error.main};
  color: ${({ theme }) => theme.colours.messaging.error.main};
  width: fit-content;
  padding: ${({ theme }) => `${theme.sizing.small} ${theme.sizing.medium}`};
  border-radius: ${({ theme }) => theme.borderRadius.secondary};
  white-space: pre-wrap;
  /*Icon matches but not text because not legibility safe in dark mode */
  svg {
    color: ${({ theme }) => theme.colours.messaging.error.main};
  }
`;
BannerErrorWrapper.displayName = 'BannerErrorWrapper';

export const BannerInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.8;
  gap: ${({ theme }) => theme.sizing.small};
  border: 1px solid ${({ theme }) => theme.colours.layering[0].weak};
  width: fit-content;
  padding: ${({ theme }) => `${theme.sizing.regular} ${theme.sizing.medium}`};
  border-radius: ${({ theme }) => theme.borderRadius.secondary};
  text-align: left;
  margin: ${({ $margin }) => $margin || 0};
  max-width: 450px;

  h3 {
    ${({ theme }) => theme.typography.headingMedium}
  }
`;
BannerInfoWrapper.displayName = 'BannerInfoWrapper';
